import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Sparkles, 
  ShieldCheck, 
  Calculator, 
  Check, 
  BadgeCheck, 
  TrendingDown, 
  ArrowRight,
  Crown,
  FileText,
  Clock,
  ArrowLeft
} from 'lucide-react';
import { WASTAGE_CATALOG } from '../components/WastageListModal';

export default function WastageListPage() {

  return (
    <div style={{ minHeight: '80vh', backgroundColor: '#07070b', color: '#fff', padding: '2rem 1rem 5rem' }}>
      <div style={{ maxWidth: '1240px', margin: '0 auto' }}>
        {/* Breadcrumbs */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '1.75rem' }}>
          <Link to="/" style={{ color: 'var(--gold-400)', textDecoration: 'none' }}>Home</Link>
          <span>/</span>
          <span style={{ color: '#fff' }}>24KT Club Wastage Rate Card</span>
        </div>

        {/* Hero Header */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.15) 0%, rgba(12, 12, 20, 0.95) 100%)',
          borderRadius: '20px',
          border: '1px solid var(--border-gold)',
          padding: '2.5rem 2rem',
          marginBottom: '2.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1.5rem'
        }}>
          <div style={{ maxWidth: '750px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '4px 12px', borderRadius: '999px', backgroundColor: 'rgba(212, 175, 55, 0.15)', border: '1px solid var(--gold-400)', color: 'var(--gold-400)', fontSize: '0.78rem', fontWeight: 700, marginBottom: '0.75rem' }}>
              <Crown size={14} /> JewelCasa Benchmark Transparency
            </div>
            <h1 style={{ fontSize: '2.2rem', fontWeight: 800, color: '#fff', marginBottom: '0.75rem', lineHeight: 1.2 }}>
              Official 24KT Club Wastage & Making Charges Rate Card
            </h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: 1.6 }}>
              Compare traditional retail jeweller wastage percentages against our ultra-transparent 24KT Club direct wholesale rates. Save between ₹5,000 to ₹35,000 on every purchase.
            </p>
          </div>

          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <Link 
              to="/wastage-calculator" 
              className="btn btn-secondary"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}
            >
              <Calculator size={16} /> Open Calculator
            </Link>
            <Link 
              to="/calculator" 
              className="btn btn-gold"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}
            >
              <Calculator size={16} /> Live Price Calculator
            </Link>
          </div>
        </div>

        {/* Rate Card Table */}
        <div style={{
          backgroundColor: '#0c0c14',
          borderRadius: '16px',
          border: '1px solid var(--border-gold)',
          overflow: 'hidden',
          marginBottom: '3rem',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
        }}>
          <div style={{
            padding: '1.25rem 1.75rem',
            backgroundColor: 'rgba(212, 175, 55, 0.05)',
            borderBottom: '1px solid rgba(212, 175, 55, 0.15)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '1rem'
          }}>
            <div>
              <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#fff', margin: 0 }}>
                Verified 2026 Wastage Breakdown by Category
              </h2>
              <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                All jewellery is 100% BIS 916 / 750 Hallmarked with verifiable 6-digit HUID laser engraving
              </span>
            </div>
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4rem',
              backgroundColor: 'rgba(52, 211, 153, 0.1)',
              color: '#34d399',
              padding: '4px 10px',
              borderRadius: '6px',
              fontSize: '0.8rem',
              fontWeight: 600
            }}>
              <BadgeCheck size={16} /> Live Verified Bullion Standard
            </span>
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '700px' }}>
              <thead>
                <tr style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)', borderBottom: '1px solid rgba(212, 175, 55, 0.2)' }}>
                  <th style={{ padding: '1rem 1.5rem', color: 'var(--text-muted)', fontSize: '0.82rem', fontWeight: 600, textTransform: 'uppercase' }}>Jewellery Category</th>
                  <th style={{ padding: '1rem 1.25rem', color: 'var(--text-muted)', fontSize: '0.82rem', fontWeight: 600, textTransform: 'uppercase' }}>Purity & Standard</th>
                  <th style={{ padding: '1rem 1.25rem', color: '#f87171', fontSize: '0.82rem', fontWeight: 600, textTransform: 'uppercase' }}>Typical Market Wastage</th>
                  <th style={{ padding: '1rem 1.25rem', color: 'var(--gold-400)', fontSize: '0.82rem', fontWeight: 700, textTransform: 'uppercase' }}>24KT Club Member Rate</th>
                  <th style={{ padding: '1rem 1.25rem', color: '#34d399', fontSize: '0.82rem', fontWeight: 700, textTransform: 'uppercase' }}>Your Net Savings</th>
                </tr>
              </thead>
              <tbody>
                {WASTAGE_CATALOG.map((item, idx) => (
                  <tr 
                    key={idx}
                    style={{
                      borderBottom: idx < WASTAGE_CATALOG.length - 1 ? '1px solid rgba(255, 255, 255, 0.06)' : 'none',
                      backgroundColor: idx % 2 === 0 ? 'transparent' : 'rgba(255, 255, 255, 0.015)'
                    }}
                  >
                    <td style={{ padding: '1.25rem 1.5rem' }}>
                      <div style={{ fontWeight: 600, color: '#fff', fontSize: '0.95rem' }}>{item.category}</div>
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '0.4rem', marginTop: '0.2rem' }}>
                        <Clock size={12} /> Ready: {item.turnaround}
                      </div>
                    </td>
                    <td style={{ padding: '1.25rem 1.25rem', color: 'var(--text-muted)', fontSize: '0.88rem' }}>
                      <span style={{ backgroundColor: 'rgba(212, 175, 55, 0.1)', color: 'var(--gold-400)', padding: '2px 8px', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 600 }}>
                        {item.purity}
                      </span>
                    </td>
                    <td style={{ padding: '1.25rem 1.25rem', color: '#f87171', fontSize: '0.95rem', fontWeight: 600 }}>
                      <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>{item.marketRate}</span>
                    </td>
                    <td style={{ padding: '1.25rem 1.25rem' }}>
                      <span style={{
                        display: 'inline-block',
                        padding: '4px 10px',
                        borderRadius: '6px',
                        backgroundColor: 'rgba(212, 175, 55, 0.15)',
                        border: '1px solid var(--gold-400)',
                        color: 'var(--gold-400)',
                        fontSize: '0.95rem',
                        fontWeight: 700
                      }}>
                        {item.regularClubRate}
                      </span>
                    </td>
                    <td style={{ padding: '1.25rem 1.25rem', color: '#34d399', fontSize: '0.95rem', fontWeight: 700 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                        <TrendingDown size={16} /> Up to 55% Off
                      </div>
                      <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)', fontWeight: 'normal' }}>
                        Wastage Margin
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* 3 Pillars of Honesty */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '3rem' }}>
          <div style={{ backgroundColor: '#0c0c14', padding: '1.75rem', borderRadius: '14px', border: '1px solid var(--border-gold)' }}>
            <ShieldCheck size={32} color="var(--gold-400)" style={{ marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#fff', marginBottom: '0.5rem' }}>
              100% Pure BIS Hallmark
            </h3>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.5 }}>
              Every jewel is stamped with government-authorized 6-digit HUID code. You can verify weight, purity, and authenticity on the BIS Care Mobile App.
            </p>
          </div>

          <div style={{ backgroundColor: '#0c0c14', padding: '1.75rem', borderRadius: '14px', border: '1px solid var(--border-gold)' }}>
            <TrendingDown size={32} color="var(--gold-400)" style={{ marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#fff', marginBottom: '0.5rem' }}>
              Direct Artisan Pricing
            </h3>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.5 }}>
              By cutting out 3 layers of middlemen and luxury showroom rent, we pass 8% to 12% in wastage savings directly to our valued patrons.
            </p>
          </div>

          <div style={{ backgroundColor: '#0c0c14', padding: '1.75rem', borderRadius: '14px', border: '1px solid var(--border-gold)' }}>
            <Crown size={32} color="var(--gold-400)" style={{ marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#fff', marginBottom: '0.5rem' }}>
              Lifetime Exchange Promise
            </h3>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.5 }}>
              100% value retention on net gold weight during exchange against the prevailing day's MCX bullion market rate with zero hidden deductions.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div style={{
          textAlign: 'center',
          padding: '3rem 2rem',
          backgroundColor: '#0c0c14',
          borderRadius: '16px',
          border: '1px solid var(--border-gold)'
        }}>
          <h2 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#fff', marginBottom: '0.5rem' }}>
            Ready to calculate your exact savings on any jewellery piece?
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', maxWidth: '600px', margin: '0 auto 1.5rem' }}>
            Use our interactive live bullion rate calculator to see instant weight and price comparison side-by-side.
          </p>
          <Link to="/wastage-calculator" className="btn btn-gold" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.8rem 2rem' }}>
            <Calculator size={18} /> Launch Wastage Calculator <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
